module.exports = __webpack_public_path__ + "img/register_banner_students.bdc5403d.svg";